export default __webpack_public_path__ + "static/14-821df444b5eb32c57f59914b191af3ff.png";